import React from "react";
import { Chip } from "@mui/material";

type PotentialFollowUpProjectChipProps = {
  visible?: boolean;
  size?: "small" | "medium";
};

/**
 * Optional secondary CRM status chip.
 * It is rendered next to the general contact-preference chip whenever a
 * contact is explicitly marked as a potential follow-up project lead.
 */
const PotentialFollowUpProjectChip: React.FunctionComponent<PotentialFollowUpProjectChipProps> = ({
  visible = false,
  size = "small",
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Chip
      size={size}
      label="Potenzielles Folgeprojekt"
      data-testid="potential-follow-up-project-chip"
      aria-label="Potenzielles Folgeprojekt"
      variant="outlined"
      sx={{
        fontWeight: 400,
        color: "#6d4c41",
        backgroundColor: "common.white",
        borderColor: "#8d6e63",
      }}
    />
  );
};

export default PotentialFollowUpProjectChip;
